import numeral from "numeral";
const discountCurrency = (price) => {
    let afterPrice = 0; 
    let format = '0,0.00'; 
    afterPrice = 'AUD $'+ numeral(price).format(format);
    return afterPrice;
  };
  
  export default discountCurrency;
  